import React, { FC, memo } from 'react'
import { FileWithPreview } from 'LibNeo'
import { canShowFile, downloadFile } from 'Helpers'
import { FileWrapperItem } from 'LibNeo/components/Basic/Upload/styled'
import { useAppDispatch } from 'Src/hooks'
import { Callback } from 'Src/types/utilTypes'
import { MODAL_NAME } from 'Constants/ModalName'
import { FileViewerComponent } from 'LibNeo/components/Basic/Upload/FileViewer.component'
import { fileSlice, modalsSlice } from 'Modules'
import { urls } from 'Constants/Urls'
import { BgLimitRequestFileItem } from './BgLimitRequestFileItem'

interface UploadPreviewProps {
	isError?: boolean
	file: Required<FileWithPreview>
	deleteFile?: Callback
	loading: boolean
}

const actions = {
	getFile: fileSlice.actions.getFile,
	removeFileCache: fileSlice.actions.removeRequestedFile,
	showModal: modalsSlice.actions.showModal,
}
export const BgLimitRequestUploadPreview: FC<UploadPreviewProps> = memo(
	({ file, deleteFile, loading, isError }) => {
		const { getFile, removeFileCache, showModal } = useAppDispatch(actions)

		const getFieleCb = (url: string) => {
			if (canShowFile(file.name)) {
				showModal({
					key: MODAL_NAME.FILE_PREVIEW,
					Component: FileViewerComponent,
					componentProps: { file: { ...file, preview: url } },
					width: 'auto',
				})
			} else {
				removeFileCache(url)
				downloadFile(url, file.name)
			}
		}

		const onViewFile = () => {
			getFile({
				url: urls.broker.document.replace(':id', file.id.toString()).concat('/file'),
				callback: getFieleCb as Callback,
			})
		}

		return (
			<FileWrapperItem fixWidth>
				<BgLimitRequestFileItem
					isError={Boolean(isError)}
					loading={loading}
					file={file}
					deleteFile={deleteFile}
					onViewFile={onViewFile}
				/>
			</FileWrapperItem>
		)
	}
)
